import React, { FC } from 'react';

import './source-icon.sass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { getIcon } from '../../utils/post-source';
import { PostType } from '../../types/Post';

export interface ISourceIconProps {
  type: PostType;
  size?: SizeProp;
  isNavItem?: boolean;
  color?: string;
}

export const SourceIcon: FC<ISourceIconProps> = ({ type, size = 'lg', isNavItem = false, color }) => {
  const icon = getIcon(type);
  if (icon) {
    return (
      <FontAwesomeIcon icon={icon.component} size={size} color={color ? color : icon.color} className='source-icon' />
    );
  } else {
    switch (type) {
      case 'tiktok':
      case 'tiktok_business':
        return (
          <img
            className={`source-icon ${isNavItem ? `source-icon--nav-item` : `source-icon--image`}`}
            src='https://cdn.hypemarks.com/assets/profile/tiktok.svg'
            alt='tiktok icon'
            style={{ height: '18px', width: '18px' }}
            data-testid={'source-icon'}
          />
        );
      case 'spark':
        return (
          <img
            className={`source-icon ${isNavItem ? `source-icon--nav-item` : `source-icon--image`}`}
            src='https://cdn.hypemarks.com/assets/profile/spark_white.png'
            alt='spark icon'
            data-testid={'source-icon'}
          />
        );
      case 'hootsuite':
        return (
          <img
            className={`source-icon ${isNavItem ? `source-icon--nav-item` : `source-icon--image`}`}
            src='/public/js/react/assets/icons/social-media-icons/hootsuite-transparent.svg'
            alt='hootsuite icon'
            style={{ height: '26px', width: '26px' }}
            data-testid={'source-icon'}
          />
        );
      case 'mission':
        return (
          <img
            className={`source-icon ${isNavItem ? `source-icon--nav-item` : `source-icon--image`}`}
            src='/public/js/react/assets/icons/vesta-logo/vesta-logo.svg'
            alt='mission icon'
            style={{ height: '18px', width: '18px' }}
            data-testid={'source-icon'}
          />
        );
      case 'creator_iq':
        return (
          <img
            className={`source-icon ${isNavItem ? `source-icon--nav-item` : `source-icon--image`}`}
            src='/public/js/react/assets/icons/social-media-icons/creatoriq-transparent.svg'
            alt='creatoriq icon'
            style={{ height: '18px', width: '18px' }}
            data-testid={'source-icon'}
          />
        );

      default:
        return null;
    }
  }
};

export default SourceIcon;
